import { useNavigate, useLocation } from "react-router-dom";
import { useAppContext } from "../AppContext";
import thanksyou from "../assets/thumbsup.jpg";
import LanguageSwitcher from "./LanguageSwitcher";
import { ES_HOME_PATH, EN_HOME_PATH, getLangFromPath } from "../routes";

const CONTENT = {
  en: {
    confirmation: "Confirmation",
    youRock: "You Rock!",
    thankYou: "Thank You!",
    emailSent: "We've sent an email confirmation to",
    emailDetails: "It will have your receipt, a link to your file, and the marketing kit",
    thanks: "Thank you",
    backHome: "Back to home",
  },
  es: {
    confirmation: "Confirmación",
    youRock: "¡Eres increíble!",
    thankYou: "¡Gracias!",
    emailSent: "Hemos enviado un correo de confirmación a",
    emailDetails: "Incluirá tu recibo, un enlace a tu archivo y el kit de marketing",
    thanks: "Gracias",
    backHome: "Volver al inicio",
  },
};

export default function DownloadPage() {
  const { email, resetPurchase } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const t = CONTENT[lang] || CONTENT.en;

  return (
    <div className="relative bg-gradient-to-br from-cyan-200 via-blue-200 to-cyan-300 overflow-hidden">
      <div className="absolute top-4 right-4 z-20">
        <LanguageSwitcher />
      </div>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 left-10 w-16 h-16 bg-white/20 rounded-full animate-bounce" />
        <div className="absolute top-32 right-20 w-12 h-12 bg-white/15 rounded-full animate-bounce" />
        <div className="absolute bottom-20 left-1/4 w-20 h-20 bg-white/10 rounded-full animate-bounce" />
        <div className="absolute top-1/2 right-10 w-8 h-8 bg-white/25 rounded-full animate-bounce" />
        <div className="absolute bottom-32 right-1/3 w-14 h-14 bg-white/15 rounded-full animate-bounce" />
      </div>

      <div className="relative z-10 container mx-auto min-h-screen flex items-center justify-center p-6">
        <div className="w-full max-w-2xl rounded-xl shadow-2xl bg-gray-50 border-3 border-[#26A94A] overflow-hidden">
          <div className="bg-slate-100 px-6 py-4 border-b border-slate-200">
            <span className="text-xl font-medium mt-2 text-[#1465B7] ">
              {t.confirmation}
            </span>
          </div>

          <div className="px-8 py-10">
            <div className="flex items-start gap-4">
              <div className="shrink-0">
                <span className="inline-flex items-center justify-center w-20 h-20 rounded-full">
                  <img src={thanksyou} alt="" />
                </span>
              </div>

              <div>
                <p className="text-emerald-600 font-semibold leading-tight">
                  {t.youRock}
                </p>
                <h1 className="text-2xl font-extrabold text-slate-800 tracking-tight">
                  {t.thankYou}
                </h1>
              </div>
            </div>

            <div className="mt-8 space-y-5 leading-7 text-[16px] font-medium text-[#1465B7]">
              <p>
                {t.emailSent}{" "}
                <span className="font-semibold">{email}</span>
              </p>
              <p>{t.emailDetails}</p>
              <p>{t.thanks}</p>
            </div>

            <div className="mt-10 flex justify-end">
              <button
                type="button"
                className="inline-flex items-center rounded-md bg-[#26A94A] text-white px-5 py-2.5 font-semibold shadow hover:bg-emerald-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/60 cursor-pointer"
                onClick={() => {
                  resetPurchase();
                  navigate(lang === "es" ? ES_HOME_PATH : EN_HOME_PATH);
                }}
              >
                {t.backHome}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
